(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/swipe-to-select/assets/javascripts/swipe-to-select.js') >= 0) return;  svs.modules.push('/components/lb-ui/swipe-to-select/assets/javascripts/swipe-to-select.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const NONE = 0;
const ADDING = 1;
const REMOVING = 2;
const CLICK_ACTIVE = 3;
const TRESHOLD = 5;
const CLASS_HOOK = 'js-swipeable';
const _React = React,
  useRef = _React.useRef,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback;
const SwipeToSelect = _ref => {
  let children = _ref.children,
    onSelect = _ref.onSelect,
    className = _ref.className,
    isSelected = _ref.isSelected,
    identifier = _ref.identifier;
  const _useState = useState(NONE),
    _useState2 = _slicedToArray(_useState, 2),
    editingMode = _useState2[0],
    setEditingMode = _useState2[1];
  const _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    forbidClickTimeout = _useState4[0],
    setForbidClickTimeout = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    forbidClick = _useState6[0],
    setForbidClick = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isTouchMoveRetrieved = _useState8[0],
    setIsTouchMoveRetrieved = _useState8[1];
  const _useState9 = useState(0),
    _useState0 = _slicedToArray(_useState9, 2),
    startX = _useState0[0],
    setStartX = _useState0[1];

  const getTargetAtCoords = (clientX, clientY) => {
    const target = document.elementFromPoint(clientX, clientY);
    const element = target && target.classList.contains(CLASS_HOOK) ? target : target && target.parentElement && target.parentElement.classList.contains(CLASS_HOOK) ? target.parentElement : null;
    return element;
  };
  const ref = useRef(null);
  const preventScrollIfTreshold = useCallback(event => {
    editingMode !== NONE && event.preventDefault();
  }, [editingMode]);
  const handleTouchStart = event => {
    setForbidClickTimeout(0);
    if (editingMode !== NONE) {
      return;
    }
    setForbidClick(true);
    const clientX = event.touches[0].clientX;
    setStartX(clientX);
    setEditingMode(isSelected ? REMOVING : ADDING);
    const currentRef = ref.current;
    currentRef.addEventListener('touchmove', preventScrollIfTreshold);
  };
  const finishTouchOrClick = function () {
    let forceSelection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let forcedSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    !isTouchMoveRetrieved && onSelect(identifier, !forceSelection ? editingMode === ADDING : forcedSelection);
    setIsTouchMoveRetrieved(false);
    setStartX(0);
    ref.current.removeEventListener('touchmove', preventScrollIfTreshold);
    requestIdleCallback(() => {
      setEditingMode(NONE);
    });
  };
  const handleTouchMove = event => {
    if (editingMode !== ADDING && editingMode !== REMOVING) {
      return;
    }
    const _event$touches$ = event.touches[0],
      clientX = _event$touches$.clientX,
      clientY = _event$touches$.clientY;

    if (Math.abs(clientX - startX) > TRESHOLD) {
      if (!isSelected) {
        onSelect(identifier, editingMode === ADDING);
      }
      const targetBtn = getTargetAtCoords(clientX, clientY);
      if (targetBtn) {
        const expectedSelectionMode = isSelected ? REMOVING : ADDING;
        const isThis = identifier === targetBtn.dataset.identifier;
        if (isThis && editingMode === expectedSelectionMode) {
          onSelect(identifier, editingMode === ADDING);
        } else {
          onSelect(targetBtn.dataset.identifier, editingMode === ADDING);
        }
      }
      setIsTouchMoveRetrieved(true);
    }
  };
  const handleTouchEnd = () => {
    editingMode !== CLICK_ACTIVE && finishTouchOrClick();
    setForbidClickTimeout(400);
  };
  const handleClick = () => {
    if (editingMode === NONE && !forbidClick) {
      setEditingMode(CLICK_ACTIVE);
      finishTouchOrClick(true, !isSelected);
    }
  };
  useEffect(() => {
    if (forbidClickTimeout !== 0) {
      setForbidClick(true);
      const timeout = setTimeout(() => {
        setForbidClick(false);
        setForbidClickTimeout(0);
      }, forbidClickTimeout);
      return () => clearTimeout(timeout);
    }
  }, [forbidClickTimeout]);
  return React.createElement("div", {
    className: "".concat("".concat(className ? "".concat(className, " ") : ''), "js-swipeable"),
    "data-identifier": identifier,
    onClick: Boolean(onSelect) && handleClick,
    onTouchEnd: Boolean(onSelect) && handleTouchEnd,
    onTouchMove: Boolean(onSelect) && handleTouchMove,
    onTouchStart: Boolean(onSelect) && handleTouchStart,
    ref: ref
  }, children);
};
setGlobal('svs.components.lbUi.swipeToSelect.SwipeToSelect', SwipeToSelect);

 })(window);